import { useState, useCallback } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useGetMasterCampaigns = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [masterCampaigns, setMasterCampaigns] = useState([]);

    const getMasterCampaigns = useCallback(async (campaignType) => {
        if (!campaignType) {
            toast.error("Campaign type is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getMasterCampaigns",
                campaignType: campaignType,
                search: "",
            });
            const campaigns = response.data.campaigns || response.data.liste || [];
            setMasterCampaigns(campaigns);
            return campaigns;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            setMasterCampaigns([]);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    const clearMasterCampaigns = useCallback(() => {
        setMasterCampaigns([]);
        setError(null);
    }, []);

    return { loading, error, masterCampaigns, getMasterCampaigns, clearMasterCampaigns };
};

export default useGetMasterCampaigns;
